import { render } from "./NapDetail.vue?vue&type=template&id=e9bb4d0c&ts=true"
import script from "./NapDetail.vue?vue&type=script&lang=ts"
export * from "./NapDetail.vue?vue&type=script&lang=ts"

import "./NapDetail.vue?vue&type=style&index=0&id=e9bb4d0c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__